import React from "react";
import KeepAlive, { useActivate, useUnactivate } from "react-activation";
import { useSearchParams } from "react-router-dom";
import Index from "./Search";

interface Props {
  pagePath?: any;
}

// 素材商品搜索页
const SearchContainer: React.FC<Props> = () => {
  // const { pagePath } = Props;
  // const navigater = useNavigate();
  const [search] = useSearchParams();
  const merchantShopCode = search.get("merchantShopCode");

  // const { getCachingNodes } = useAliveController();

  useActivate(() => {
    console.log("search444------");
  });

  useUnactivate(() => {
    console.log("search444------");
  });

  return (
    <KeepAlive cacheKey={`promote-search-${merchantShopCode}`} saveScrollPosition={true}>
      <Index />
    </KeepAlive>
  );
};

export default SearchContainer;
